import type { CSSProperties } from "react";

import { HANDLE_HALF_SIZE, HANDLE_SIZE, type ResizeHandle } from "./modal-open-pdf.lib";

type SelectionRect = {
  x: number;
  y: number;
  w: number;
  h: number;
};

type SelectionOverlayProps = {
  rect: SelectionRect;
  isActive: boolean;
};

type ResizeHandleConfig = {
  handle: ResizeHandle;
  position: CSSProperties;
  cursor: string;
};

const RESIZE_HANDLES: ResizeHandleConfig[] = [
  { handle: "nw", position: { top: -HANDLE_HALF_SIZE, left: -HANDLE_HALF_SIZE }, cursor: "nwse-resize" },
  { handle: "ne", position: { top: -HANDLE_HALF_SIZE, right: -HANDLE_HALF_SIZE }, cursor: "nesw-resize" },
  { handle: "sw", position: { bottom: -HANDLE_HALF_SIZE, left: -HANDLE_HALF_SIZE }, cursor: "nesw-resize" },
  { handle: "se", position: { bottom: -HANDLE_HALF_SIZE, right: -HANDLE_HALF_SIZE }, cursor: "nwse-resize" },
];

const SelectionOverlay = ({ rect, isActive }: SelectionOverlayProps) => (
  <div className="absolute z-10" style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }}>
    <div className="border-system-info-50 bg-system-info-50/20 pointer-events-none absolute inset-0 border-2" />
    {isActive
      ? RESIZE_HANDLES.map(({ handle, position, cursor }) => (
          <div
            key={handle}
            data-handle={handle}
            className="border-system-info-50 absolute z-20 rounded-sm border-2 bg-white"
            style={{ ...position, width: HANDLE_SIZE, height: HANDLE_SIZE, cursor }}
          />
        ))
      : null}
  </div>
);

export default SelectionOverlay;
